// TitleManager.jsx
import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function TitleManager() {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  // Define aquí tus títulos (puedes usar claves de i18n)
  const titles = useMemo(() => ({
    "/": t("titles.home", "Inicio"),
    "/dashboard": t("titles.dashboard", "Dashboard"),
    "/perfil-usuario": t("titles.profile", "Perfil de usuario"),
    "/administracion/comunidades": t("titles.communities", "Comunidades"),
    "/administracion/intermediarios": t("titles.brokers", "Intermediarios"),
    "/administracion/paises": t("titles.countries", "Países"),
    "/administracion/productores": t("titles.producers", "Productores"),
    "/administracion/provincias": t("titles.provinces", "Provincias"),
    "/administracion/usuarios": t("titles.users", "Usuarios"),
    "/centros-productores": t("titles.centers", "Centros productores"),
    "/gestores": t("titles.managers", "Gestores"),
    "/residuos": t("titles.waste", "Residuos"),
    "/informes/cantidades-generadas": t("titles.report.quantities", "Informe - Cantidades generadas"),
    "/informes/costes": t("titles.report.costs", "Informe - Costes"),
    "/informes/huella-carbono": t("titles.report.carbon", "Informe - Huella de carbono"),
    "/informes/segregacion-valorizacion": t("titles.report.segregation", "Informe - Segregación y valorización"),
    "/components": t("titles.components", "Components"),
    "/login": t("titles.login", "Acceso")
  }), [t]);

  useEffect(() => {
    // Soporta rutas con parámetros (ej.: /gestores/:id)
    const staticMatch = titles[pathname];
    let computed = staticMatch;

    if (!computed) {
      // Reglas simples para rutas con :id
      if (pathname.startsWith("/gestores/")) {
        computed = t("titles.managerDetail", "Gestor");
      } else if (pathname.startsWith("/centros-productores/")) {
        computed = t("titles.centerDetail", "Centro productor");
      } else if (pathname.startsWith("/administracion/productores/")) {
        computed = t("titles.producerDetail", "Productor");
      } else if (pathname.startsWith("/obras-menores/")) {
        computed = t("titles.smallWorksDetail", "Obra menor");
      }
    }

    const appName = "WLC";
    document.title = computed ? `${computed} | ${appName}` : appName;
  }, [pathname, titles, t]);

  return null;
}